import { connect } from 'react-redux';
import {
  accessingCurrentSpaceAsStaff,
  commonRoomPostsExcludingRecentImportantSelector,
  participantCount,
  recentImportantPostsSelector,
} from '@core/selectors/classroom';
import { getCurrentSpaceId } from '@core/selectors/space';
import CommonRoomResponsive from './CommonRoomResponsive';

const mapStateToProps = (state) => {
  const recentPosts = recentImportantPostsSelector(state);
  const posts = commonRoomPostsExcludingRecentImportantSelector(state);

  return {
    participantTotal: participantCount(state),
    spaceId: getCurrentSpaceId(state),
    posts: [...recentPosts, ...posts].filter(Boolean),
    readOnly: accessingCurrentSpaceAsStaff(state),
  };
};

export default connect(mapStateToProps)(CommonRoomResponsive);
